import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.89005 9C10.1252 8.33167 10.5892 7.76811 11.2 7.40913C11.8108 7.05016 12.5289 6.91894 13.2272 7.03871C13.9255 7.15849 14.5589 7.52152 15.0151 8.06353C15.4714 8.60553 15.7211 9.29152 15.72 10C15.72 12 12.72 13 12.72 13M12.8 17H12.81M8.60005 21H17C18.6802 21 19.5203 21 20.162 20.673C20.7265 20.3854 21.1854 19.9265 21.4731 19.362C21.8 18.7202 21.8 17.8802 21.8 16.2V7.8C21.8 6.11984 21.8 5.27976 21.4731 4.63803C21.1854 4.07354 20.7265 3.6146 20.162 3.32698C19.5203 3 18.6802 3 17 3H8.60005C6.91989 3 6.07981 3 5.43808 3.32698C4.87359 3.6146 4.41465 4.07354 4.12703 4.63803C3.80005 5.27976 3.80005 6.11984 3.80005 7.8V16.2C3.80005 17.8802 3.80005 18.7202 4.12703 19.362C4.41465 19.9265 4.87359 20.3854 5.43808 20.673C6.07981 21 6.91989 21 8.60005 21Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }